var styleDataHash = '54fd65ca';  
export const injectCss = (() => {
  var css = `.-Cv-f{height:100%;max-width:100%;position:relative;width:100%}.q6dNd{background:rgba(51,51,51,.05);bottom:0;left:0;position:absolute;right:0;top:0}._4lKTZ{border:0;height:100%;overflow:hidden;width:100%}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});





